export default "__VITE_ASSET__BIfp_6TU__"